<template>
  <b-modal
    id="alert-modal-cart"
    ref="alert-modal-cart"
    size="sm"
    centered
    :hide-header="true"
    :hide-footer="true"
    v-model="cart_warning"
  >
    <div class="alert-modal-body">
      <div class="modal-close">
        <a
          href="javascript:void(0)"
          class
          data-dismiss="modal"
          @click="hideCartWarning"
        >
          <svg class="closeIcon" fill="none">
            <use xlink:href="#closeIcon" />
          </svg>
        </a>
      </div>
      <div>
        <div class="icon mb-3">
          <svg
            class="error-icon"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 130.2 130.2"
          >
            <circle
              class="path circle"
              fill="none"
              stroke="#D06079"
              stroke-width="8"
              stroke-miterlimit="10"
              cx="65.1"
              cy="65.1"
              r="62.1"
            />
            <line
              class="path line"
              fill="none"
              stroke="#D06079"
              stroke-width="8"
              stroke-linecap="round"
              stroke-miterlimit="10"
              x1="34.4"
              y1="37.9"
              x2="95.8"
              y2="92.3"
            />
            <line
              class="path line"
              fill="none"
              stroke="#D06079"
              stroke-width="8"
              stroke-linecap="round"
              stroke-miterlimit="10"
              x1="95.8"
              y1="38"
              x2="34.4"
              y2="92.2"
            />
          </svg>
        </div>
        <p
          class="mb-0 error"
          v-html="
            `You have items in cart from <span>${msgKey}. </span><br />Do you want to clear cart?`
          "
        ></p>
        <div class="alert-modal-footer d-block text-center mt-3">
          <button class="btn btn-outline btn-success" @click="addToCart">
            {{ _T('Yes') }}
          </button>
          <button
            class="btn btn-cancel btn-outline btn-danger"
            @click="hideCartWarning"
          >
            {{ _T('Cancel') }}
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { isObjectEmpty } from '@/utils/main_utils'

export default {
  name: 'cartAlert',
  computed: {
    ...mapState({
      item: state => state.cart_store.selectedItem,
    }),
    ...mapGetters([
      'cart_warning',
      'cart_brand',
      'cart_store',
      'selected_modifiers',
      '_T_DB',
      '_T',
      'itemModifierGroups',
      'itemModifierSubgroupsByGroup',
      'modifiersInSubgroup',
      'cart_brand_store',
      'brandStoreRoute',
      'brandStoreParams',
    ]),
    msgKey() {
      let msg = ''
      if (this.cart_warning === 2) {
        msg = this._T_DB(this.cart_brand.data, 'name')
      } else if (this.cart_warning === 1) {
        msg = 'store, ' + this._T_DB(this.cart_store, 'name')
      }
      return msg
    },
  },
  methods: {
    ...mapActions(['addItemToCart']),
    validateModifiersSelection() {
      this.errors = {}
      //find in subgroups if it is mandatory then its subgroup id should be found in selected_modifiers
      this.itemModifierGroups(this.item).forEach(group => {
        this.itemModifierSubgroupsByGroup(group).forEach(subgroup => {
          if (this.modifiersInSubgroup(group, subgroup)) {
            if (
              subgroup.item_type == 'mandatory' &&
              !this.selected_modifiers.some(
                mod => mod.modifier_sub_group == subgroup._id
              )
            ) {
              //this.errors[subgroup._id] = this._T(`Please select at least one modfiier from '${this._T_DB(subgroup, 'name')}'`)
              this.errors[subgroup._id] = this._T(`Please select at least one`)
            }
          }
        })
      })
      this.$store.commit('MODIFIER_ERRORS', this.errors)
      return isObjectEmpty(this.errors)
    },
    addToCart() {
      this.$store.commit('CLEAR_CART', true)
      this.$store.dispatch('resetCoupon')
      let item = { ...this.$store.state.cart_store.selectedItem }
      //attach modifiers here

      item.modifiers = this.selected_modifiers
      if (this.validateModifiersSelection()) {
        this.addItemToCart(item)
        this.$store.commit('SET_ITEM_DETAIL_POPUP', false)
        document.body.classList.remove('body-overlay')
        let urlHasProduct = this.$route.name
        if (urlHasProduct === 'product_landing_page') {
          this.$router.push({
            // name: this.brandStoreRoute('cart'),
            name: this.brandStoreRoute('store_page'),
            params: {
              ...this.brandStoreParams,
            },
          })
        }
      }
      this.$store.commit('STORE_CHANGE_WARN', false)
    },
    hideCartWarning() {
      this.$store.commit('SET_ITEM_DETAIL_POPUP', false)
      document.body.classList.remove('body-overlay')
      this.$store.commit('STORE_CHANGE_WARN', false)
    },
  },
}
</script>

<style lang="scss">
.btn-cancel {
  margin-left: 10px;
}
#alert-modal-cart {
  .modal-dialog {
    max-width: $px450;
    .modal-content {
      height: $px250;
      justify-content: center;
      border-radius: $px8;
      // box-shadow: 0px 0px 6px 1px $color-primary;
      .alert-modal-body {
        padding: $px10;
        height: 100%;
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        .modal-close {
          position: absolute;
          right: $px5;
          top: $px2;
          svg {
            width: $px18;
            height: $px18;
          }
        }
        .icon {
          svg {
            width: $px50;
            display: block;
            margin: 0 auto;
          }
          .path {
            stroke-dasharray: 1000;
            stroke-dashoffset: 0;
            &.circle {
              -webkit-animation: dash 0.9s ease-in-out;
              animation: dash 0.9s ease-in-out;
            }
            &.line {
              stroke-dashoffset: 1000;
              -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
              animation: dash 0.9s 0.35s ease-in-out forwards;
            }
            &.check {
              stroke-dashoffset: -100;
              -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
              animation: dash-check 0.9s 0.35s ease-in-out forwards;
            }
          }
        }
        .btn {
          &.btn-success {
            color: $white !important;
            background-color: #28a745 !important;
            border-color: #28a745 !important;
          }
        }
        p {
          font-size: $px14;
          text-align: center;
          font-weight: 600;
          &.success {
            color: $dine-success;
          }
          &.error {
            color: $color-primary;
            span {
              color: $color-secondary;
            }
          }
        }
      }
    }
  }
}
@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}

@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
</style>
